import {IRegistration} from "../../store/registrations/interfaces";
import {IProgram} from "../../store/program/interfaces";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export function useNumPaymentsEnabled() {
    const { payment_configuration } = useSelector(
        (state: RootState) => state.program.data,
    );
    return (payment_configuration.cash.enabled ? 1 : 0) +
        (payment_configuration.transfer.enabled ? 1 : 0) +
        (payment_configuration.debit.enabled ? 1 : 0) +
        (payment_configuration.online.enabled ? 1 : 0) +
        (payment_configuration.custom.enabled ? 1 : 0) +
        (payment_configuration.invoice.enabled ? 1 : 0);
}

export const useCheckPaymentStageSkip = () => {
    const { payment_configuration } = useSelector(
        (state: RootState) => state.program.data,
    );
    const registrations = useSelector(
        (state: RootState) => state.registrations.list,
    );
    const { basic_fee } = useSelector((state: RootState) => state.program.data);
    const totalCost = registrations.reduce((acc, reg) => acc + reg.price, 0);

    // Check if payment configuration is enabled
    const anyPaymentConfigEnabled = useNumPaymentsEnabled() > 1;

    // Determine whether to skip the payment stage based on provided cases
    return (totalCost === 0 && !basic_fee) ||
        (!anyPaymentConfigEnabled && totalCost === 0 && !basic_fee) ||
        (totalCost === 0 && !anyPaymentConfigEnabled);
};
